export const TARGET_GROUP_FOR_DISPLAY: Record<string, string> = {
  "Venture Capital": "VC",
  PRS: "PRS",
};
